export enum StatisticsMeasureItems {
  Corners = 'corners',
  YellowCards = 'yellowCards',
  ShotsOffTarget = 'shotsOffTarget',
  ShotsOnTarget = 'shotsOnTarget',
  FreeKicks = 'freeKicks',
  Offsides = 'offsides',
  RedCards = 'redCards'
}
